import { Box, SxProps, Theme } from '@mui/material';

type ProgressBarProps = Readonly<{
  progress: number;
  total: number;
}>;

export const ProgressBar = ({ progress, total }: ProgressBarProps) => {
  return (
    <Box sx={wrapperStyles}>
      <Box sx={barWrapperStyles}>
        <Box sx={barStyles} width={`${(progress / total) * 100}%`}></Box>
      </Box>
    </Box>
  );
};

const wrapperStyles: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Background/bg-quaternary'],
  borderRadius: backrs.radius['radius-xs'],
  width: '100%',
  height: '8px',
});

const barWrapperStyles: SxProps<Theme> = ({ backrs }) => ({
  borderRadius: backrs.radius['radius-xs'],
  width: 'auto',
  height: '100%',
  overflow: 'hidden',
});

const barStyles: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Foreground/fg-brand-primary'],
  borderRadius: backrs.radius['radius-md'],
  height: '100%',
});
